import PhraseBuilderLayout from "../../components/algorithm/PhraseBuilderLayout";

const AlgorithmPage = () => {
  return <PhraseBuilderLayout />;
};

export default AlgorithmPage;
